import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TeacherPortfolioRecordTypeEnum } from '@isophi/pap-api';

export enum BaseModeEnum {
  VIEW = 'view',
  EDIT = 'edit',
}

@Component({
    selector: 'isophi-app-portfolio-plan-base-item',
    templateUrl: './portfolio-plan-base-item.component.html',
    styleUrls: ['./portfolio-plan-base-item.component.scss'],
    standalone: false
})
export class PortfolioPlanBaseItemComponent {
  @Input()
  leftIcon = '';

  @Input()
  rightIcon = 'edit';

  @Input()
  allowEditMode = true;

  @Input()
  title = '';

  @Input()
  shared: TeacherPortfolioRecordTypeEnum | null = null;

  @Input()
  onCardClick?: () => void;

  @Input()
  get mode(): BaseModeEnum {
    return this._mode;
  }
  set mode(value: BaseModeEnum) {
    this._mode = value;
  }

  @Output()
  modeChange = new EventEmitter<BaseModeEnum>();

  modeEnum = BaseModeEnum;
  recordTypeEnum = TeacherPortfolioRecordTypeEnum;

  private _mode: BaseModeEnum = BaseModeEnum.VIEW;

  isViewMode(): boolean {
    return this.mode === this.modeEnum.VIEW;
  }

  isEditMode(): boolean {
    return this.mode === this.modeEnum.EDIT;
  }

  setMode(mode: BaseModeEnum): void {
    if (!this.allowEditMode && mode === this.modeEnum.EDIT) {
      return;
    }

    this.mode = mode;
    this.modeChange.emit(mode);
  }

  handleRightIconClick(): void {
    if (this.mode === this.modeEnum.EDIT) return;
    if (this.mode === this.modeEnum.VIEW && this.allowEditMode) {
      if (this.onCardClick) {
        this.onCardClick();
      } else {
        this.setMode(this.modeEnum.EDIT);
      }
    }
  }
}
